import { EntityModel } from "./entity.model";

export interface ExperienceModel extends EntityModel {
    from?: Date;
    to?: Date;
    type?: string;
    details?: string;
}
